import { render, staticRenderFns } from "./Modal.htm?vue&type=template&id=66fd645a&scoped=true&"
import script from "./Modal.js?vue&type=script&lang=js&"
export * from "./Modal.js?vue&type=script&lang=js&"
import style0 from "./Modal.scss?vue&type=style&index=0&id=66fd645a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd645a",
  null
  
)

export default component.exports